var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gl-page-wrapper container join"},[(_vm.joinStep === 0)?_c('join-preview',{on:{"next":function($event){_vm.joinStep++}}}):(_vm.joinStep === 1)?_c('join-form',{on:{"next":function($event){_vm.joinStep++}}}):_c('join-success')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }